import { IUserProfile } from "../../platform.type";

export function getHostAppVersion(): string {
  try {
    if (typeof Office === "undefined") return "";
    
    return Office?.context?.mailbox?.diagnostics?.hostVersion
      ?? Office.context?.diagnostics?.version
      ?? navigator.userAgent;
  } catch {
    return null;
  }
}

/**
 * Return the Outlook / Office host user profile synchronously when available.
 * Returns null when running outside an Outlook host or if accessing Office APIs fails.
 */
export function getUserProfile(): IUserProfile | null {
  try {
    if (typeof Office === "undefined") return null;

    const profile = Office?.context?.mailbox?.userProfile;
    if (!profile) return null;

    const { emailAddress, displayName, timeZone } = profile;
    return { emailAddress, displayName, timeZone };
  } catch {
    return null;
  }
}